import React, { useEffect, useRef, useState } from 'react';
import FreeCamToggle from './FreeCamToggle';
import MuteToggle from './MuteToggle';
const NAME_TEXT = 'Sai Dheeraj Gollu';
const TITLE_TEXT = 'Full-Stack Software Engineer';
const MULTIPLIER = 1;
const InfoOverlay = ({ visible }) => {
    const visRef = useRef(visible);
    const [nameText, setNameText] = useState('');
    const [titleText, setTitleText] = useState('');
    const [time, setTime] = useState(new Date().toLocaleTimeString());
    const timeRef = useRef(time);
    const [timeText, setTimeText] = useState('');
    const [textDone, setTextDone] = useState(false);
    const [volumeVisible, setVolumeVisible] = useState(false);
    const [freeCamVisible, setFreeCamVisible] = useState(false);
    const typeText = (i, curText, text, setText, callback, refOverride) => {
        if (refOverride) {
            text = refOverride.current;
        }
        if (i < text.length) {
            setTimeout(() => {
                if (visRef.current === true)
                    window.postMessage({ type: 'keydown', key: `_AUTO_${text[i]}` }, '*');
                setText(curText + text[i]);
                typeText(i + 1, curText + text[i], text, setText, callback, refOverride);
            }, Math.random() * 50 + 50 * MULTIPLIER);
        }
        else {
            callback();
        }
    };
    useEffect(() => {
        if (visible && nameText == '') {
            setTimeout(() => {
                typeText(0, '', NAME_TEXT, setNameText, () => {
                    typeText(0, '', TITLE_TEXT, setTitleText, () => {
                        typeText(0, '', time, setTimeText, () => {
                            setTextDone(true);
                        }, timeRef);
                    });
                });
            }, 400);
        }
        visRef.current = visible;
    }, [visible]);
    useEffect(() => {
        if (textDone) {
            setTimeout(() => {
                setVolumeVisible(true);
                setTimeout(() => {
                    setFreeCamVisible(true);
                }, 250);
            }, 250);
        }
    }, [textDone]);
    useEffect(() => {
        window.postMessage({ type: 'keydown', key: `_AUTO_` }, '*');
    }, [freeCamVisible, volumeVisible]);
    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        timeRef.current = time;
        textDone && setTimeText(time);
    }, [time]);
    return (React.createElement("div", { style: styles.wrapper },
        nameText !== '' && (React.createElement("div", { style: styles.container },
            React.createElement("p", null, nameText))),
        titleText !== '' && (React.createElement("div", { style: styles.container },
            React.createElement("p", null, titleText))),
        timeText !== '' && (React.createElement("div", { style: styles.lastRow },
            React.createElement("div", { style: Object.assign({}, styles.container, styles.lastRowChild) },
                React.createElement("p", null, timeText)),
            volumeVisible && (React.createElement("div", { style: styles.lastRowChild },
                React.createElement(MuteToggle, null))),
            freeCamVisible && (React.createElement("div", { style: styles.lastRowChild },
                React.createElement(FreeCamToggle, null)))))));
};
const styles = {
    container: {
        background: 'black',
        padding: 4,
        paddingLeft: 16,
        paddingRight: 16,
        textAlign: 'center',
        display: 'flex',
        marginBottom: 4,
        boxSizing: 'border-box',
    },
    wrapper: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    blinkingContainer: {
        // width: 100,
        // height: 100,
        marginLeft: 8,
        paddingBottom: 2,
        paddingRight: 4,
    },
    lastRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    lastRowChild: {
        marginRight: 4,
    },
};
export default InfoOverlay;
